import rain from "@/assets/map/rain.png";
import temp from "@/assets/map/temp.png";
import leida from "@/assets/map/leida.png";
import tem2 from "@/assets/map/pressure.png";
import hum from "@/assets/map/hum.png";
import windIcon from "@/assets/map/windIcon.png";
import off from "@/assets/map/off.png";

import raina from "@/assets/map/raina.png";
import tempa from "@/assets/map/tempa.png";
import leidaa from "@/assets/map/leidaa.png";
import tema2 from "@/assets/map/pressurea.png";
import huma from "@/assets/map/huma.png";
import windIcona from "@/assets/map/windIcona.png";
import offa from "@/assets/map/offa.png";


import vector from "@/assets/map/vector.png";
import satellitepoi from "@/assets/map/satellitepoi.png";
import terrain from "@/assets/map/terrain.png";


export default {
  rain,
  temp,
  leida,
  tem2,
  hum,
  windIcon,
  off,
  raina,
  tempa,
  leidaa,
  tema2,
  huma,
  windIcona,
  offa,
  vector,
  satellitepoi,
  terrain
};
